<div
  class="main-wrapper"
  [class.pd-0]="!showHeader && headerType !== 'site'"
  [class.kyc-page]="isKycPage"
  [dir]="textDirection"
  [class.arebic-font]="textDirection === 'rtl'"
>
  @if (showSiteHeader && headerType === 'site') {
    <div class="page-header">
      <taly-site-header />
    </div>
  } @else {
    @if (showHeader) {
      <taly-header />
    }
  }

  <main class="page-body">
    <router-outlet />
  </main>

  @if (showFooter) {
    <footer class="page-footer">
      <taly-footer />
    </footer>
  }
  <p-toast position="bottom-center"></p-toast>

  <taly-user-idle />
</div>

<!-- ngx-ui-loader with custom template -->
<ngx-ui-loader [fgsTemplate]="customSpinner"></ngx-ui-loader>

<!-- Define the custom template -->
<ng-template #customSpinner>
  <div class="custom-spinner-container">
    <img src="assets/images/taly-dark-icon.svg" alt="Taly-logo" class="taly-logo" />

    <div class="loader"></div>
  </div>
</ng-template>
